document.querySelectorAll('.block_product_tab_col li').forEach(function(item) {
    item.addEventListener('click', function() {
        var tabId = this.getAttribute('data-tab');
        document.querySelectorAll('.block_product_tab_col li').forEach(function(li) {
            li.classList.remove('active');
        });
        this.closest('.block_product_tabify_wrapper').querySelectorAll('.block_product_tab_description_wrapper').forEach(function(product) {
            product.classList.remove('active');
        });
        this.classList.add('active');
        document.getElementById(tabId).classList.add('active');
    });
  });
  